import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";

@Injectable()
export class SalesService extends Base2Service {
    getSales(id:number):Observable<ResponseApi>{
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + `sales/${id}`);
    }
}